function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTidal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1453 1453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M261.8 325.3h2.8c21.5 24.6 45.8 46.5 68.7 70.1L488.8 551v2.8c-75.3 75-150.3 150.7-225.7 225.7-75.7-75.3-151-151-226.7-226.4 3.9-7.4 11.3-12.3 16.9-18.3 69.4-70 139.8-139 208.5-209.5zm454.1 0h2.8c2.1 3.2 4.2 6 7 8.8 72.9 72.2 144.7 145.4 218.3 217.2-1.8 4.2-5.6 7-8.8 10.2-72.8 72.6-145.3 145.5-218.2 218-76-75-150.7-151.4-227.1-226 73.9-77.1 151.7-151.4 226-228.2zm454.2 0h2.8c14.1 16.9 30.6 31.3 45.8 47.2l170.8 170.8c2.8 3.2 7.4 6 8.4 10.6-76.4 74.3-150.3 151.4-227.1 225.7L954.3 563c-3.5-3.9-8.1-6.7-9.9-11.6 38.4-37.3 75.7-75.7 113.7-113.4 37.4-37.7 75.4-74.3 112-112.7zm-677 677.8c74.3-74.3 148.9-148.6 223.2-223.2l3.2 1.4c74.6 75 149.3 150 224.6 224.3-2.5 5.6-7.7 8.8-11.6 13.4-54.2 53.9-108.4 108.4-162.7 162.3-17.6 16.9-34.5 35.9-52.5 51.8-25.7-23.2-49.3-49.3-74.3-73.2-50.7-50.7-101-101.4-152.1-151.7.8-1.6 1.5-3.7 2.2-5.1z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.094
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTidal);
export default __webpack_public_path__ + "static/media/tidal.119f415da7b9ee736ee7885662c90409.svg";
export { ForwardRef as ReactComponent };